import React, { useEffect, useState } from "react";
import { useTranslation } from "../../../context/TranslationContext";

const Pagethree = ({ formdata, setformdata, validSteps, setvalidSteps }) => {
  const { getOfferStep3Title, getOfferStep3Option1, getOfferStep3Option2 } =
    useTranslation();
  const [categoryType, setcategoryType] = useState(formdata.categoryType);
  useEffect(() => {
    setformdata({ ...formdata, categoryType: categoryType, Categories: [] });
    setvalidSteps({ ...validSteps, 3: categoryType > 0 });
  }, [categoryType]);
  return (
    <div className="flex flex-col mb-7">
      <div className="flex justify-center mb-6">
        <span className="md:text-25 text-15 text-black font-medium">
          {getOfferStep3Title}
        </span>
      </div>
      <div className="grid sm:grid-cols-2 grid-cols-1 gap-6">
        <label className="w-full font-bold sm:text-[18px] text-15 h-16 px-5 bg-[#f5f5f5] flex items-center justify-between cursor-pointer">
          {getOfferStep3Option1}
          <input
            type="radio"
            value="1"
            name="topping"
            className="w-8 h-8"
            onChange={() => setcategoryType(1)}
            checked={categoryType == 1}
          />
        </label>
        <label className="w-full font-bold sm:text-[18px] text-15 h-16 px-5 bg-[#f5f5f5] flex items-center justify-between cursor-pointer">
          {getOfferStep3Option2}
          <input
            type="radio"
            name="topping"
            value="2"
            className="w-8 h-8"
            onChange={() => setcategoryType(2)}
            checked={categoryType == 2}
          />
        </label>
      </div>
    </div>
  );
};

export default Pagethree;
